import React from 'react';
import get from 'lodash/get';
import { Box } from '@material-ui/core';
import amezonlogo from '../../images/amazonLogo.svg';

const SourceImgField = ({ record }) => {
  const SourceType = get(record, 'source');

  let sourceImg = (
    <svg
      className="tool_icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.6888 18.6688L16.3888 13.3688H15.3988L12.8588 15.9088V16.8988L18.1588 22.1988C18.5488 22.5888 19.1788 22.5888 19.5688 22.1988L21.6888 20.0788C22.0788 19.6988 22.0788 19.0588 21.6888 18.6688ZM18.8588 20.0888L14.6188 15.8488L15.3288 15.1388L19.5688 19.3788L18.8588 20.0888Z"
        fill="black"
      />
      <path
        d="M17.3588 10.6888L18.7688 9.27878L20.8888 11.3988C22.0588 10.2288 22.0588 8.32878 20.8888 7.15878L17.3488 3.61878L15.9388 5.02878V2.20878L15.2388 1.49878L11.6988 5.03878L12.4088 5.74878H15.2388L13.8288 7.15878L14.8888 8.21878L11.9988 11.1088L7.8688 6.97878V5.55878L4.8488 2.53878L2.0188 5.36878L5.0488 8.39878H6.4588L10.5888 12.5288L9.7388 13.3788H7.6188L2.3188 18.6788C1.9288 19.0688 1.9288 19.6988 2.3188 20.0888L4.4388 22.2088C4.8288 22.5988 5.4588 22.5988 5.8488 22.2088L11.1488 16.9088V14.7888L16.2988 9.63878L17.3588 10.6888ZM9.3788 15.8388L5.1388 20.0788L4.4288 19.3688L8.6688 15.1288L9.3788 15.8388Z"
        fill="black"
      />
    </svg>
  );
  let imgClass = 'tool_icon_box';

  if (SourceType == 'InShop') {
    sourceImg = (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="8" fill="#919EAB" fillOpacity="0.24" />
        <rect
          x="0.5"
          y="0.5"
          width="47"
          height="47"
          rx="7.5"
          stroke="#919EAB"
          strokeOpacity="0.24"
        />
        <path
          d="M13.0547 30.76V20.7903H33.9483V30.76"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0195 30.76V24.5134H25.3889V30.76"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 20.75H34.75"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.8949 30.7601V25.5986H29.1289V30.7601"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0195 25.7754H25.3889"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0195 27.0208H25.3889"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0195 28.2671H25.3889"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0195 29.5122H25.3889"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7601 16.5H18.0767C17.8445 16.5 17.6562 16.686 17.6562 16.9155V18.6411C17.6562 18.8706 17.8445 19.0566 18.0767 19.0566H23.7601C23.9923 19.0566 24.1805 18.8706 24.1805 18.6411V16.9155C24.1805 16.686 23.9923 16.5 23.7601 16.5Z"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.8418 19.5569V20.3568"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.1289 19.5569V20.3568"
          stroke="black"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="11" y="31.332" width="25" height="0.667463" fill="#181818" />
      </svg>
    );
  }

  if (SourceType == 'MSS') {
    sourceImg = (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="8" fill="#919EAB" fillOpacity="0.24" />
        <rect
          x="0.5"
          y="0.5"
          width="47"
          height="47"
          rx="7.5"
          stroke="#919EAB"
          strokeOpacity="0.24"
        />
        <path
          d="M31.5001 19C30.6763 17.767 29.5605 16.7567 28.2521 16.0588C26.9436 15.361 25.483 14.9973 24.0001 15C22.5198 14.9991 21.0621 15.3637 19.7565 16.0615C18.4509 16.7593 17.3379 17.7687 16.5161 19M23.5001 15C22.7207 16.2486 22.1069 17.5932 21.6741 19M24.5 15C25.2801 16.2485 25.8945 17.5931 26.328 19M31.5001 29C30.6763 30.233 29.5605 31.2434 28.2521 31.9412C26.9436 32.639 25.483 33.0027 24.0001 33C22.5198 33.0009 21.0621 32.6363 19.7565 31.9385C18.4509 31.2407 17.3379 30.2313 16.5161 29M23.5001 33C22.7207 31.7514 22.1069 30.4068 21.6741 29M24.5 33C25.2801 31.7515 25.8945 30.4069 26.328 29M14 22L15 26L16.5 22L18 26L19 22M29 22L30 26L31.5 22L33 26L34 22M21.5 22L22.5 26L24 22L25.5 26L26.5 22"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (SourceType === 'Amazon' || SourceType === 'AmazonMP') {
    sourceImg = (
      <img src={amezonlogo} alt="Company logo" width="48" height="48" />
    );
  }

  if (SourceType === 'Simple') {
    sourceImg = (
      <svg
        className="st_icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M13.3019 17.4409V11.2601H18.486C18.4895 11.3407 18.4907 11.4212 18.4907 11.5018C18.4907 14.5039 16.2662 17.0416 13.3019 17.4409ZM19.7817 9.70808L19.7675 9.6524L6.79254 9.65003C7.59618 7.168 9.87491 5.50699 12.4959 5.50699C14.4595 5.50699 16.2674 6.4536 17.392 8.04944H19.1468C17.8499 5.54846 15.321 4 12.4959 4C8.4659 4 5.17347 7.15023 5 11.1866V11.2601H11.6922V17.4409C9.21525 17.1092 7.23035 15.2894 6.66745 12.863H5.12509C5.77885 16.4291 8.84234 19 12.4959 19C16.6309 19 19.9976 15.6365 20 11.5018C20 10.8928 19.9268 10.2898 19.7817 9.70808Z"
          fill="#181818"
        />
      </svg>
    );
    imgClass = 'st_icon_box';
  }
  return <Box className={imgClass}>{sourceImg}</Box>;
};

SourceImgField.defaultProps = {
  addLabel: true,
};

export default SourceImgField;
